'use client';

import { LoginProviderButton } from '@/components/login/LoginProviderButton';
import { MicrosoftLogo } from '@/components/login/Logos';
import { Button } from '@venienergygroup/shared-components';
import { ComponentProps, FC } from 'react';

type Props = ComponentProps<typeof Button> & { isPending: boolean };

const MicrosoftButton: FC<Props> = ({ isPending, children, ...rest }) => {
  return (
    <LoginProviderButton isPending={isPending} logo={<MicrosoftLogo />} {...rest}>
      {children}
    </LoginProviderButton>
  );
};

export default MicrosoftButton;
